import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { WEBSITE_CRM_CONNECT_TRANSITION_MARKDOWN } from './websiteCrmDemoContent.part01.js'
import { WEBSITE_CRM_CRM_TEST_LOG_BLOCK_INDEX } from './websiteCrmDemoContent.part03.js'
import { buildWebsiteCrmPhase1FinalBlocks } from './websiteCrmDemoContent.part07.js'
import { buildWebsiteCrmConnectFinalBlocks } from './websiteCrmDemoContent.part10.js'

export function buildWebsiteCrmFullFinalBlocks(htmlArtifactId, zohoArtifactId, docArtifactId) {
  const websiteBlocks = buildWebsiteCrmPhase1FinalBlocks(htmlArtifactId)
  const connectBlocks = buildWebsiteCrmConnectFinalBlocks(
    zohoArtifactId,
    docArtifactId,
    htmlArtifactId,
  )
  const connectWithAgentSwitch = [
    ...connectBlocks.slice(0, WEBSITE_CRM_CRM_TEST_LOG_BLOCK_INDEX),
    buildSelectionSwitchBlock('agent', 'Software Engineering', 'Research'),
    ...connectBlocks.slice(WEBSITE_CRM_CRM_TEST_LOG_BLOCK_INDEX),
  ]

  return [
    ...websiteBlocks,
    { type: 'markdown', content: WEBSITE_CRM_CONNECT_TRANSITION_MARKDOWN },
    ...connectWithAgentSwitch,
  ]
}

/**
 * @param {string} htmlArtifactId
 * @param {string} zohoArtifactId
 * @param {string} docArtifactId
 * @returns {object[]}
 */
/**
 * @param {string} htmlArtifactId
 * @param {string} zohoArtifactId
 * @param {string} docArtifactId
 * @returns {object[]}
 */
